module.exports = __webpack_public_path__ + "static/img/g-share-icon.020a6e25.png";